import React from "react";
import { Eye, LogOut } from "lucide-react";

export const startPreview = (token) => {
  localStorage.setItem("el_owner_token", localStorage.getItem("el_token"));
  localStorage.setItem("el_token", token);
};

export const PreviewBanner = () => {
  const ownerToken = localStorage.getItem("el_owner_token");
  const label = localStorage.getItem("el_preview_label") || "";
  if (!ownerToken) return null;

  const back = () => {
    localStorage.setItem("el_token", ownerToken);
    localStorage.removeItem("el_owner_token");
    localStorage.removeItem("el_preview_label");
    window.location.href = "/owner";
  };

  return (
    <div data-testid="preview-banner"
      className="fixed bottom-0 inset-x-0 z-[999] flex flex-wrap items-center justify-center gap-3
        px-4 py-2 text-xs font-black text-[#05122e]"
      style={{ background: "linear-gradient(90deg,#ffd166,#ff9f1c)" }}>
      <span className="flex items-center gap-2"><Eye size={14} />
        وضع المعاينة — تشاهد الموقع كما يراه: {label}</span>
      <button onClick={back} data-testid="exit-preview-btn"
        className="rounded-full bg-[#05122e] text-white px-3 py-1 flex items-center gap-1">
        <LogOut size={12} />رجوع لحساب المالك</button>
    </div>
  );
};
